import React from "react";
import Particles from "../../Particles/Particles";
import HeroSection from "./HeroSection";
import "./government.css";
import KeyChallenges from "./KeyChallenges";
import KeyFeatures from "./KeyFeatures";
import HowItWorks from "./HowItWorks";
import TechnologyStack from "./TechnologyStack";
import CallToAction from "./CallToAction";
import Benefits from "./Benefits";

const Government = () => {
  return (
    <div className="government-industry-wrapper">
      <Particles title="government" />
      <HeroSection />
      <KeyChallenges />
      <KeyFeatures />
      <Benefits />
      <HowItWorks />
      <TechnologyStack />
      <CallToAction />
    </div>
  );
};

export default Government;
